import { Component } from '@angular/core';
import { NavigationBarService } from '../navigation-bar.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { CategoryInterface } from 'src/app/interfaces/lobby.interface';
import { ControlHelperService } from 'src/app/services/control/control-helper.service';
import { filter, first } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';

@UntilDestroy()
@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NavigationItemComponent
  ]
})
export class TopBarComponent {
  public isHorizontal = false;
  public activeLink$ = this.controlHepler.activeLobbyCategory$;
  public links$: Observable<CategoryInterface[]>;

  constructor(
    private navigationBarService: NavigationBarService,
    private controlHepler: ControlHelperService,
  ) {
    this.links$ = this.navigationBarService.getNavigationBar('TOPHEADER');
  }

  public selectLink(item: CategoryInterface) {
    this.controlHepler.activeLobbyCategory$.pipe(
      first(),
      untilDestroyed(this),
      filter((data: CategoryInterface) => data?.id !== item.id),
    ).subscribe(() => {
      this.navigationBarService.selectLink(item);
    }).unsubscribe();
  }

  public get activeLink(): Observable<any> {
    return this.controlHepler.activeLobbyCategory$;
  }
}
